import { profile } from "../../data/resume";

function Intro() {
    return (
        <section id="home" className="hero">
            <div className="container hero-inner">
                <div className="hero-avatar-wrap">
                    <img className="hero-avatar" src="/aanish-image.jpeg" alt={profile.name} />
                </div>
                <div className="hero-content">
                    <p className="hero-eyebrow">Hello, I'm</p>
                    <h1 className="hero-name">{profile.name}</h1>
                    <p className="hero-title">{profile.title}</p>
                    <a className="upwork-badge" href={profile.upwork} target="_blank" rel="noreferrer">
                        ⭐ Top Rated Plus on Upwork
                    </a>
                    <p className="hero-punchline">{profile.punchLine}</p>
                    <div className="hero-actions">
                        <a className="btn-accent" href={`mailto:${profile.email}`}>
                            <img src="/icons/icons8-gmail-login-100.png" alt="" />
                            Get in touch
                        </a>
                        <a className="btn-outline" href={profile.github} target="_blank" rel="noreferrer">
                            <img src="/icons/icons8-github-100.png" alt="" />
                            GitHub
                        </a>
                        <a className="btn-outline" href={profile.linkedin} target="_blank" rel="noreferrer">
                            <img src="/icons/icons8-linkedin-100.png" alt="" />
                            LinkedIn
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Intro;
